import React, { useState } from "react";
import "./admissionFormModal.css";
import ReCAPTCHA from "react-google-recaptcha";

const AdmissionFormModal = ({ isOpen, onClose, onSubmit }) => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    mobile: "",
  });

  const [errors, setErrors] = useState({});
  const [captchaToken, setCaptchaToken] = useState("");

  const validateEmail = (email) => {
    const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return regex.test(email);
  };

  const validateMobile = (mobile) => {
    const regex = /^[6-9]\d{9}$/;
    return regex.test(mobile);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
    setErrors({ ...errors, [name]: "" });
  };

  const handleCaptcha = (token) => {
    setCaptchaToken(token);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const newErrors = {};

    if (!formData.name.trim()) newErrors.name = "Name is required";

    if (!formData.email.trim()) {
      newErrors.email = "Email is required";
    } else if (!validateEmail(formData.email)) {
      newErrors.email = "Invalid email format";
    }

    if (!formData.mobile.trim()) {
      newErrors.mobile = "Mobile number is required";
    } else if (!validateMobile(formData.mobile)) {
      newErrors.mobile = "Invalid mobile number";
    }

    if (!captchaToken) {
      newErrors.captcha = "Please verify you are not a robot";
    }

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return;
    }

    try {
      const response = await fetch("https://api.mitadtu.in/api/submit-form", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          ...formData,
          captchaToken,
        }),
      });

      const data = await response.json();

      alert("Form submitted successfully");

      onSubmit(formData);

      setFormData({
        name: "",
        email: "",
        mobile: "",
      });

      setCaptchaToken("");

    } catch (error) {
      console.error("Error:", error);
    }
  };

  if (!isOpen) return null;

  return (
    <div className="b-modal-overlay" onClick={onClose}>
      <div className="b-modal-content" onClick={(e) => e.stopPropagation()}>
        <button className="b-modal-close" onClick={onClose}>
          &times;
        </button>

        <h1 className="title" style={{ fontSize: "clamp(14px, 3vw, 30px)" }}>
          Download Brochure
        </h1>

        <h2 className="subtitle">Please fill in your details</h2>

        <form onSubmit={handleSubmit} className="admission-form">

          <div className="form-group">
            <input
              type="text"
              name="name"
              placeholder="Full Name"
              value={formData.name}
              onChange={handleChange}
              className={errors.name ? "error" : ""}
            />
            {errors.name && <span className="error-text">{errors.name}</span>}
          </div>

          <div className="form-group">
            <input
              type="email"
              name="email"
              placeholder="Email Address"
              value={formData.email}
              onChange={handleChange}
              className={errors.email ? "error" : ""}
            />
            {errors.email && <span className="error-text">{errors.email}</span>}
          </div>

          <div className="form-group">
            <input
              type="tel"
              name="mobile"
              placeholder="Mobile Number"
              value={formData.mobile}
              onChange={handleChange}
              maxLength="10"
              className={errors.mobile ? "error" : ""}
            />
            {errors.mobile && (
              <span className="error-text">{errors.mobile}</span>
            )}
          </div>

          <div className="form-group">
            <ReCAPTCHA
              sitekey="6Lcq_oksAAAAAC-BJy6doTZgsW_qW8oHcvDiUX7d"
              onChange={handleCaptcha}
            />
            {errors.captcha && (
              <span className="error-text">{errors.captcha}</span>
            )}
          </div>

          <button type="submit" className="submit-btn">
            Download Brochure
          </button>

        </form>
      </div>
    </div>
  );
};

export default AdmissionFormModal;